import BaseCalendarIteractiveController from "./base_calendar_iteractive_controller";
import 'select2';
import 'select2/dist/css/select2';
import { animateModalContainer, closeScheduleModal } from "./calendar/modal-mask-iterations";
import { isEmpty } from "lodash";
import tippy from "tippy.js";
import Mustache from "mustache";
import LeadService from "../entrypoints/src/admin/services/lead-service";
import AjaxLoader from "../entrypoints/src/admin/utilities/ajax-loader";
import Swal from "sweetalert2";
import 'tippy.js/themes/light.css';
import '../styles/partials/_card-menu.scss';
import PipelineService from "../entrypoints/src/admin/services/pipeline-service";

export default class extends BaseCalendarIteractiveController {
  static targets = [
    'agenda',
    'form',
    'inputDate',
    'inputViewMode',
    'selectService',
    'selectExperimentalService',
    'selectProfessor',
    'selectLocation',
    'scheduleModalMask',
    'experimentalModal',
    'newEnrollmentModal',
    'batchName',
    'experimentalBaseMessage',
    'experimentalLeadName',
    'experimentalValue',
    'experimentalPhoneNumber',
    'experimentalEmail',
    'experimentalStartTime',
    'experimentalEndTime',
    'experimentalWeekDay',
    'experimentalProfessor',
    'experimentalProfessorContainer',
    'experimentalPipeline',
    'experimentalStage'
  ];

  static values = {
    scheduleExperimental: Boolean,
    calendarService: String
  }

  connect() {
    this.element[this.identifier] = this;

    this.initializeBase();
    this.initializeCardProperties();
    this.bindSelect2();

    if (!!this.scheduleExperimentalValue) {
      this.element.querySelectorAll('.table-row .table-cell .table-cell-container').forEach(($el) => $el.classList.add('action-on-hover'));
      this.element.querySelectorAll('.table-row .table-cell').forEach(($tableCell) => {
        $tableCell.addEventListener('click', (ev) => {
          if (!ev.target.classList.contains('table-cell-container')) return;
          if (!ev.target.classList.contains('disabled')) return this.openCellActions($tableCell);

          this.askPermission('Horário está desabilitado. Tem certeza que deseja continuar?').then(() => this.openCellActions($tableCell));
        });
      });

      this.element.querySelectorAll('.calendar-daily .hour-band').forEach(($band) => {
        let $cardsList = $band.querySelector('.cards-list');
        if (!$cardsList) return;

        $cardsList.classList.add('action-on-hover');

        $band.addEventListener('click', (ev) => {
          if (!ev.target.classList.contains('cards-list')) return;
          if (!$band.classList.contains('disabled')) return this.openCellActions($band);

          this.askPermission('Horário está desabilitado. Tem certeza que deseja continuar?').then(() => this.openCellActions($band));
        });
      });
    }

    $(this.selectServiceTarget).on('change', (_ev) => {
      this.element.querySelectorAll('.clear-on-service').forEach(($input) => $input.value = '');
      this.submitForm();
    });

    this.hasScheduleModalMaskTarget && this.prepareScheduleModal();
    this.hasNewEnrollmentModalTarget && this.bindEventsAtEnrollmentModal();
  }

  bindSelect2() {
    $(this.element.querySelectorAll('.filters .select2')).select2({
      placeholder: { id: 0, text: 'Todos' },
      multiple: false,
      allowClear: true,
      escapeMarkup: (markup) => markup,
      dropdownParent: this.element.querySelector('.modal.modal-body')
    });

    !!this.hasExperimentalPipelineTarget && this.experimentalPipelineTarget.addEventListener('initialize', (e) => {
      const tomselect = e.detail.tomselect;
      tomselect.on('change', (e) => this.updateStages(tomselect.getValue()));
    });
  }

  updateStages(pipelineId) {
    if (!this.hasExperimentalPipelineTarget)
      return;

    PipelineService.stages(pipelineId)
      .then(data => {
        const tomselect = this.experimentalStageTarget.tomselect;
        tomselect.clear();
        tomselect.clearOptions();
        data.forEach(stage => tomselect.addOption({ value: stage.id, text: stage.name }));
        tomselect.refreshOptions();
      })
      .catch(error => console.error('Error fetching stages:', error));
  }

  prepareScheduleModal() {
    [...this.scheduleModalMaskTarget.querySelectorAll('.close-action'), this.scheduleModalMaskTarget].forEach(($el) => $el.addEventListener('click', (ev) => this.onCloseScheduleModal(ev)));

    $(this.element.querySelector('.schedule-modal-mask .select-service')).select2({
      placeholder: '-- selecione --',
      multiple: false,
      allowClear: true,
      escapeMarkup: (markup) => markup,
      dropdownParent: this.element.querySelector('.schedule-modal-mask .schedule-modal')
    });

    $('#lead-select').select2({
      placeholder: 'Nome do Interessado',
      tags: true,
      dropdownParent: this.scheduleModalMaskTarget.querySelector('.schedule-modal')
    }).on('select2:select', (ev) => this.onLeadSelect(ev.target));

    $('body').on('click', '.add-experimental', (ev) => {
      ev.preventDefault();
      this.openBatchExperimentalDialog(ev.currentTarget.closest('[data-tippy-root]')._tippy);
    });

    $(this.scheduleModalMaskTarget).on('keydown', (ev) => {
      if (ev.target.classList.contains('select2-search__field'))
        return;

  		if (ev.code === 'NumpadEnter' || ev.code === 'Enter') {
				ev.preventDefault();
				ev.stopPropagation();
				this.scheduleExperimental();
			}
    });
  }

  bindEventsAtEnrollmentModal() {
    $(this.newEnrollmentModalTarget).on('keydown', (ev) => {
  		if (ev.code === 'NumpadEnter' || ev.code === 'Enter') {
				ev.preventDefault();
				ev.stopPropagation();
				this.continueEnrollment();
			}
    });
  }

  async onLeadSelect(select) {
    let leadId = select.selectedOptions[0].dataset.leadId;

    if (!leadId)
      return;

    try {
      let response = await LeadService.find(leadId);

      if (!!response.contacts && response.contacts.length > 0) {
        this.experimentalPhoneNumberTarget.value = response.contacts[0].number;
      }

      this.experimentalEmail.value = response.email;
    } catch (ex) {}
  }

  openBatchExperimentalDialog(tippy) {
    let $batchCard = tippy._card;
    this.askConfirmation($batchCard.closest('.table-cell, .hour-band')).then(() => {
      let tableCell = $batchCard.closest('.table-cell, .hour-band'),
        schedule = JSON.parse($batchCard.dataset.schedule);
      this.experimentalModalTarget.classList.remove('d-none');
      this.selectedCard = $batchCard;
      this.experimentalStartTimeTarget.value = tableCell.dataset.startTime;
      this.experimentalEndTimeTarget.value = tableCell.dataset.endTime;
      this.experimentalStartTimeTarget.setAttribute('disabled', '');
      this.experimentalEndTimeTarget.setAttribute('disabled', '');
      this.batchNameTarget.innerHTML = schedule['level_name'];
      this.batchNameTarget.classList.toggle('hidden', false);
      this.experimentalWeekDayTarget.innerHTML = $batchCard.closest('.table-cell, .hour-band').dataset.dayShort;
      this.hasExperimentalProfessorContainerTarget && this.experimentalProfessorContainerTarget.classList.toggle('hidden', true);

      animateModalContainer(this.selectedCard, this.scheduleModalMaskTarget, this.experimentalModalTarget);
      tippy.hide();
    });
  }

  openCellActions(tableCell) {
    if (!this.hasSelectServiceTarget || this.selectServiceTarget.selectedOptions[0].dataset.classesFormat != 'individual')
      return this.openExperimentalDialog(tableCell);

    !!tableCell._tippy && tableCell._tippy.destroy();

    tippy(tableCell, {
      content: Mustache.render(document.querySelector('#card__cell-actions').content.children[0].innerHTML, tableCell.dataset),
      trigger: 'click', // mouseenter, click, focus; manual.
      placement: 'auto-end',
      appendTo: document.body,
      arrow: true,
      allowHTML: true,
      theme: 'light',
      animation: 'scale',
      interactive: true,
      onShown: async (instance) => {
        instance.popper.querySelector('a.new-enrollment').addEventListener('click', () => this.clickToNewEnrollment(instance, tableCell));
        instance.popper.querySelector('a.experimental-attendance').addEventListener('click', () => {
          instance.hide();
          this.openExperimentalDialog(tableCell);
        });
      }
    }).show();
  }

  clickToNewEnrollment(instance, tableCell) {
    if (!this.hasNewEnrollmentModalTarget)
      return;

    instance.hide();
    this.newEnrollmentModalTarget.classList.remove('d-none');
    this.selectedCard = this.createCard(tableCell, '', 'Nova Matrícula');
    this.prepareNewEnrollmentModal(tableCell);
    animateModalContainer(this.selectedCard, this.scheduleModalMaskTarget, this.newEnrollmentModalTarget);
    this.selectedCard.style.removeProperty('z-index');
    this.newEnrollmentModalTarget.querySelector('form #enrollment-student-name').focus();
  }

  prepareNewEnrollmentModal(tableCell) {
    const formTemplate = document.getElementById('new-enrollment-form').innerHTML;
    this.newEnrollmentModalTarget.querySelector('.template-rendered').innerHTML = Mustache.render(formTemplate, tableCell.dataset);
  }

  continueEnrollment(ev) {
    let studentName = this.newEnrollmentModalTarget.querySelector('form #enrollment-student-name'),
      formGroup = studentName.closest('.form-group'),
      feedback = formGroup.querySelector('.message');
    formGroup.classList.remove('has-error');
    !!feedback && feedback.remove();

    if (!studentName.value || studentName.value.trim().length == 0) {
      formGroup.classList.toggle('has-error', true);
      formGroup.insertAdjacentHTML('beforeend', `<div class="message text-rose">não pode ficar em branco</div>`);
      return;
    }

    AjaxLoader.show();
    let form = this.newEnrollmentModalTarget.querySelector('form');
    form.submit();
  }

  openExperimentalDialog(tableCell) {
    this.askConfirmation(tableCell).then(() => {
      this.experimentalModalTarget.classList.remove('d-none');
      this.selectedCard = this.createCard(tableCell);
      this.experimentalStartTimeTarget.value = tableCell.dataset.startTime;
      this.experimentalEndTimeTarget.value = tableCell.dataset.endTime;
      this.experimentalWeekDayTarget.innerHTML = tableCell.dataset.dayShort;
      this.experimentalStartTimeTarget.removeAttribute('disabled');
      this.experimentalEndTimeTarget.removeAttribute('disabled');
      this.professorRequired = true;
      this.hasExperimentalProfessorContainerTarget && this.experimentalProfessorContainerTarget.classList.toggle('hidden', false);

      animateModalContainer(this.selectedCard, this.scheduleModalMaskTarget, this.experimentalModalTarget);
      this.selectedCard.style.removeProperty('z-index');
    });
  }

  askPermission(text) {
    return new Promise((resolve, reject) => {
      return Swal.fire({
        html: text,
        showClass: { backdrop: 'swal2-noanimation', popup: '', },
        hideClass: { popup: '' },
        customClass: {
          cancelButton: 'btn btn-gray-primary',
          confirmButton: 'btn btn-primary mr-3'
        },
        buttonsStyling: false,
        showCancelButton: true,
        focusCancel: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Sim, continuar'
      }).then((result) => {
        if (result.value)
          return resolve();

        reject();
      });
    });
  }

  askConfirmation(tableCell) {
    return new Promise((resolve, reject) => {
      let [year, month, date] = tableCell.dataset.date.split('-'),
        cellDate = new Date(year, month - 1, date),
        currentDate = new Date();

      currentDate.setHours(0);
      currentDate.setMinutes(0);
      currentDate.setSeconds(0);
      currentDate.setMilliseconds(0);

      if (cellDate < currentDate) {
        return Swal.fire({
          title: 'Atenção',
          html: "Tem certeza que deseja agendar aula experimental com data <b>retroativa</b>?",
          icon: 'warning',
          showClass: { backdrop: 'swal2-noanimation', popup: '', },
          hideClass: { popup: '' },
          customClass: {
            cancelButton: 'btn btn-gray-primary',
            confirmButton: 'btn btn-primary mr-3'
          },
          buttonsStyling: false,
          showCancelButton: true,
          focusCancel: true,
          cancelButtonText: 'Cancelar',
          confirmButtonText: 'Sim, tenho certeza'
        }).then((result) => {
          if (result.value)
            return resolve();

          reject();
        });
      }

      resolve();
    })
  }

  createCard($cell, cssStyle = '', title = 'Aula Experimental') {
    let uid = `id-${new Date().getTime() + Math.ceil(Math.random() * 10)}`,
      $container = $cell.querySelector('.table-cell-container') || $cell.querySelector('.cards-list') || $cell;

    $container.insertAdjacentHTML('beforeEnd', `
      <div class="card selected-schedule draft ${cssStyle}" id="${uid}">
        <div class="content">
          <div class="content-container">
            <div class="line-clamp-1 title">${title}</div>
            <div class="time">${$cell.dataset.startTime} às ${$cell.dataset.endTime}</div>
          </div>
        </div>
      </div>
    `);

    return $container.querySelector(`#${uid}`);
  }

  // save the experimental schedule
  async scheduleExperimental() {
    AjaxLoader.show();
    this.clearFormState();

    if (!this.validateLead()) {
      AjaxLoader.hide();
      return;
    }

    let $cell = this.selectedCard.closest('.table-cell, .hour-band'),
      params = {
        utm: 'experimental',
        name: this.experimentalLeadNameTarget.value,
        mobile_number: this.experimentalPhoneNumberTarget.value,
        email: this.experimentalEmailTarget.value,
        date: $cell.dataset.date,
        service_id: this.selectExperimentalServiceTarget.value,
        value: this.experimentalValueTarget.value,
        stage_id: (this.hasExperimentalStageTarget ? this.experimentalStageTarget.value : null)
      };

    if (!!this.selectedCard.dataset.batchScheduleId) {
      params['batch_schedule_id'] = this.selectedCard.dataset.batchScheduleId;
      params['batch_id'] = this.selectedCard.dataset.batchId;
    } else {
      params['start_time'] = this.experimentalStartTimeTarget.value;
      params['end_time'] = this.experimentalEndTimeTarget.value;
      params['professor_id'] = (this.hasExperimentalProfessorTarget ? this.experimentalProfessorTarget.value : (this.hasSelectProfessorTarget ? this.selectProfessorTarget.value : null));
      params['location_id'] = (this.hasExperimentalLocationTarget ? this.experimentalLocationTarget.value : (this.hasSelectLocationTarget ? this.selectLocationTarget.value : null))

      if (!params['location_id'])
        delete params.location_id;

      if (!params['professor_id'])
        delete params.professor_id;
    }

    this.experimentalModalTarget.classList.add('d-none');

    try {
      await LeadService.create({ utm: 'experimental', lead: params });

      Swal.fire('Pronto', 'Aula experimental agendada com sucesso', 'success').then(() => {
        window.location.reload();
      });
    } catch (ex) {
      AjaxLoader.hide();
      this.experimentalModalTarget.classList.remove('d-none');
      Swal.fire('Atenção', 'Infelizmente não foi possível agendar aula. Tente novamente!', 'error');
    }
  }

  validateLead() {
    let valid = true;

    if (isEmpty(this.experimentalLeadNameTarget.value)) {
      this.invalidateFormControl(this.experimentalLeadNameTarget);
      valid &= false;
    }

    if (isEmpty(this.experimentalEmailTarget.value) && isEmpty(this.experimentalPhoneNumberTarget.value)) {
      this.experimentalBaseMessageTarget.classList.toggle('hidden', false);
      this.experimentalBaseMessageTarget.innerHTML = 'Preencha pelo menos um contato do interessado: <b>telefone</b> ou <b>email</b>';
      return false;
    }

    if (!!this.professorRequired && isEmpty(this.experimentalProfessorTarget.value)) {
      this.experimentalBaseMessageTarget.classList.toggle('hidden', false);
      this.experimentalBaseMessageTarget.innerHTML = 'Escolha um professor';
      return false;
    }

    return valid;
  }

  resetExperimentalDialog() {
    this.clearFormState();
    this.batchNameTarget.innerHTML = '';
    this.batchNameTarget.classList.toggle('hidden', true);
    this.experimentalLeadNameTarget.value = this.experimentalPhoneNumberTarget.value = this.experimentalEmailTarget.value = '';
  }

  clearFormState() {
    [this.experimentalLeadNameTarget, this.experimentalPhoneNumberTarget, this.experimentalEmailTarget].map((it) => this.clearFormControlState(it));
    this.experimentalBaseMessageTarget.classList.toggle('hidden', true) && (this.experimentalBaseMessageTarget.innerHTML = '');
  }

  invalidateFormControl(formControl) {
    this.applyFormControlState(formControl, true);
  }

  clearFormControlState(formControl) {
    this.applyFormControlState(formControl, false);
  }

  applyFormControlState(formControl, inValid) {
    let formGroup = formControl.closest('.form-group');

    if (!formGroup)
      return;

    formGroup.classList.toggle('has-error', inValid);
    formGroup.querySelectorAll('.error-message').forEach(($el) => $el.classList.toggle('hidden', !inValid));
    formControl.classList.toggle('is-invalid', inValid);
  }

  async onCloseScheduleModal(ev) {
    try {
      await closeScheduleModal.bind(this)(ev);

      this.selectedCard.classList.contains('draft') && this.selectedCard.remove();
      this.scheduleModalMaskTarget.querySelectorAll('.schedule-modal-container').forEach((element) => { element.classList.toggle('d-none', true) });
      this.resetExperimentalDialog();
    } catch (ex) {}
  }

  disconnect() {
    this.element.querySelector('input.input-date-attendance')._flatpickr.destroy();
  }
}